import { Brand, Duration } from 'effect';
import { std } from './js';

export namespace Time {
    export type CreateOptions = {
        /** @default 0 */
        days?: number;
        /** @default 0 */
        hours?: number;
        /** @default 0 */
        minutes?: number;
        /** @default 0 */
        seconds?: number;
        /** @default 0 */
        ms?: number;
    };

    /** Milliseconds */
    export type MS = Brand.Branded<number, 'ms'>;
    export const MS = Brand.nominal<Time.MS>();
    export function ms(options: CreateOptions): Time.MS {
        let ms = 0;

        if (options.ms) ms += options.ms;

        let multiply = 1000;
        if (options.seconds) ms += options.seconds * multiply;

        multiply *= 60;
        if (options.minutes) ms += options.minutes * multiply;

        multiply *= 60;
        if (options.hours) ms += options.hours * multiply;

        multiply *= 24;
        if (options.days) ms += options.days * multiply;

        return ms as Time.MS;
    }

    export type Seconds = Brand.Branded<number, 'seconds'>;
    export const Seconds = Brand.nominal<Time.Seconds>();
    export function seconds(options: CreateOptions): Time.Seconds {
        return (Time.ms(options) / 1000) as Time.Seconds;
    }
}

export type Duration_TimeStamp = Brand.Branded<`${number}:${number}`, 'Duration_TimeStamp'>;
export namespace Duration_TimeStamp {
    export const nominal = Brand.nominal<Duration_TimeStamp>();

    export function fromDuration(duration: Duration.Duration): Duration_TimeStamp {
        const parts = Duration.parts(duration);

        const hours = parts.hours + parts.days * 24;

        return Duration_TimeStamp.nominal(
            `${hours.toString().padStart(2, '0') as unknown as number}:${parts.minutes.toString().padStart(2, '0') as unknown as number}`,
        );
    }

    export function parse(timestamp: Duration_TimeStamp): Duration.Duration | null {
        if (!timestamp.includes(':')) return null;

        const [hours, minutes] = timestamp.split(':').map(std.Number.safeParseInt);

        if (typeof hours !== 'number' || typeof minutes !== 'number') return null;

        return Duration.minutes(hours * 60 + minutes);
    }
}
